import * as $ from 'jquery';
import * as k from 'kendo';
import * as app from 'CMS/core/application'

let _theMessages: any;
const i18nStateAttribute = 'data-i18n-state';
const i18nStateTranslated = 'translated';
const i18nStateNotFound = 'notfound';

export function initialize(o: any) {
    _theMessages = o;
};
export function getMessage(key: string, ...args: string[]) {    
    let ret = getValueByString(_theMessages, key);
    if (ret == null) { ret = "i18n: " + key.toLowerCase(); }

    const kendoArgs = Array.prototype.slice.call(args); // clone args
    kendoArgs.unshift(ret); // add translated message to arguments array
    return k.format.apply(this, kendoArgs);
};

export function getMessageOrDefault(key: string, defaultValue: string, ...args: string[]) {    
    let ret = getValueByString(_theMessages, key);
    if (ret == null) {
        if (defaultValue != null) {
            ret = defaultValue; //set default value.
        } else {
            return "i18n: " + key.toLowerCase(); //no default value provided => return default message
        }
    }

    var kendoArgs = Array.prototype.slice.call(args);
    kendoArgs.unshift(ret); // add translated message to arguments array
    return k.format.apply(this, kendoArgs);
};

export function getMessageOrDefaultWithoutFormat(key: string, defaultValue: string) {    
    let ret = getValueByString(_theMessages, key);
    if (ret != null) { return ret; }

    if (ret == null && defaultValue != null) {
        return defaultValue;
    }
    return "i18n: " + key.toLowerCase(); //no default value provided => return default message
};

export function bind($root: JQuery, data?: any) {
    if (data == null) { data = _theMessages; }
    const $translated = _initI18nDataAttr($root, data);
    const $translated2 = _initI18nDataValue($root, data);
    $translated.forEach($element => setTranslated($element));
    $translated2.forEach($element => setTranslated($element));
}


function _initI18nDataContent($root: JQuery, data?: any): JQuery[] {
    var $elements = $root.find("[data-i18n-value]");
    var $translated = [] as JQuery[];
    $.each($elements, function (i, element) {
        var $element = $(element);

        /* get i18n-value data attribute */
        var i18nValue = $element.data('i18n-value');

        /* retrieve key part of the data attribute (part before first ,) */
        var key = null;
        var formatArgs = null;
        if (i18nValue != null) {
            var splitted = i18nValue.split(',');
            key = splitted.shift(); /* take first element (=key) from 'splitted' array and remove it */
            formatArgs = splitted; /* remainder of the array are arguments for kendo.format(..) */
        }

        /* retrieve i18n message from key */
        var text = null;
        if (key != null) {
            text = getValueByString(data, key);

            /* check if we need to use kendo.format */
            if (text != null && formatArgs != null && formatArgs.length > 0) {
                formatArgs.unshift(text); // add translated message to arguments array                             
                text = k.format.apply(this, formatArgs);
            }
        }

        if (text == null) {
            /* try default value */
            text = $element.data('i18n-value-default');
        }

        if (text == null) {
            /* Check current value */
            if ($element.is('input')) {
                text = $element.val();
            } else {
                text = $element.text();
            }

            if ((text == null || text == '') && key != null) {
                /* set message for not found keys */
                text = "i18n: " + key.toLowerCase();
            }
        }

        if (text != null) {
            if ($element.is('input')) {
                $element.val(text);
            } else {
                $element.text(text);
            }
        }

        $translated.push($element);
    });

    return $translated;
}

function _initI18nDataValue($root: JQuery, data?: any): JQuery[] {
    var $elements = $root.find("[data-i18n-value]");
    var $translated = [] as JQuery[];
    $.each($elements, function (i, element) {
        var $element = $(element);

        /* get i18n-value data attribute */
        var i18nValue = $element.data('i18n-value');

        /* retrieve key part of the data attribute (part before first ,) */
        var key = null;
        var formatArgs = null;
        if (i18nValue != null) {
            var splitted = i18nValue.split(',');
            key = splitted.shift(); /* take first element (=key) from 'splitted' array and remove it */
            formatArgs = splitted; /* remainder of the array are arguments for kendo.format(..) */
        }

        /* retrieve i18n message from key */
        var text = null;
        if (key != null) {
            text = getValueByString(data, key);

            /* check if we need to use kendo.format */
            if (text != null && formatArgs != null && formatArgs.length > 0) {
                formatArgs.unshift(text); // add translated message to arguments array                             
                text = k.format.apply(this, formatArgs);
            }
        }

        if (text == null) {
            /* try default value */
            text = $element.data('i18n-value-default');
        }

        if (text == null) {
            /* Check current value */
            if ($element.is('input')) {
                text = $element.val();
            } else {
                text = $element.text();
            }

            if ((text == null || text == '') && key != null) {
                /* set message for not found keys */
                text = "i18n: " + key.toLowerCase();
            }
        }

        if (text != null) {
            if ($element.is('input')) {
                $element.val(text);
            } else {
                $element.text(text);
            }
        }

        $translated.push($element);
    });

    return $translated;
}

function _initI18nDataAttr($root: JQuery, data?: any): JQuery[] {
    const $translated = [] as JQuery[];
    var $elements = $root.find("[data-i18n-attr]");
    $.each($elements, function (i, element) {
        var $element = $(element);
        if (isTranslated($element)) { return; }

        var dataValue = $element.data('i18n-attr').split(":");

        var attr = dataValue[0].trim();
        var key = dataValue[1].trim();

        var text = getValueByString(data, key);
        if (text == null) {
            /* try default value */
            dataValue = $element.data('i18n-attr-default');
            if (dataValue != null) {
                text = dataValue.split(":")[1].trim();
            } else {
                text = "i18n: " + key.toLowerCase();
            }
        }

        if (text != null) { $element.attr(attr, text); }
    });

    return $translated;
}

function isTranslated($element: JQuery): boolean {
    return $element.attr(i18nStateAttribute) === i18nStateTranslated;
}
function setTranslated($element: JQuery) {
    $element.attr(i18nStateAttribute, i18nStateTranslated);
}

/**
 * o = object
 */
function getValueByString(o: any, s: string) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        o = getParameterCaseInsensitive(o, k);

        if (o == null) {
            var logMessage = "Message with ID: " + s + " not found!";
            console.log(logMessage)
            $.ajax({
                type: "POST",
                url: app.formatLocationUrl("~/awf/api/") + 'Logs/LogJavascriptWarn',
                data: JSON.stringify({ message: logMessage, tags: ['MissingTranslation'] }),
                contentType: "application/json; charset=utf-8"
            });
            return;
        }
    }
    return o;
}

/**
  * @param {Object} object
  * @param {string} key
  * @return {any} value
 */
function getParameterCaseInsensitive(object: any, key: string) {
    return object[Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase())];
}



/**
 * (DEPRECATED) Use i18n.bind instead in combination with the data-i18n-value attribute
 * @param $root
 */
export function initializeDOMElements($root: JQuery) {
    var $elements = $root.find("[data-i18n-content]");
    $.each($elements, function (i, element) {
        const $element = $(element);
        const message = getMessageOrDefault($element.data('i18n-content'), $element.text());
        $element.text(message);
    });
}